"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Game_1 = require("./Game");
const IGO50Terminal_1 = require("./IGO50Terminal");
const KHInputProvider_1 = require("./KH/Input/KHInputProvider");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const IGO50PausableScene_1 = require("./IGO50PausableScene");
const Z20SceneNames_1 = require("./Z20SceneNames");
const Z20TerminalSetup_1 = require("./Z20TerminalSetup");
var Z20Achievements;
(function (Z20Achievements) {
    Z20Achievements["Streak1"] = "forestwernat_streak1";
    Z20Achievements["Streak3"] = "forestwernat_streak3";
    Z20Achievements["Fast"] = "forestwernat_fast";
})(Z20Achievements || (Z20Achievements = {}));
class Z20MenuScene extends IGO50PausableScene_1.default {
    constructor() {
        super(Z20SceneNames_1.default.Menu);
    }
    create() {
        // this.audio_scene.play('bg_audio', true, true, 0.5)
        IGO50Terminal_1.default.CurrentCode = undefined;
        this._controller = Game_1.gameManager.getController();
        this._controller.register(KHInputScene_1.KHInputScene.SharedInput);
        this._startText = this.add.bitmapText(Game_1.game.width / 2, 10 * 16, 'igo50', 'PRESS Z').setOrigin(.5, 0).setDepth(5);
        this.add.bitmapText(Game_1.game.width / 2, 12.5 * 16, 'igo50', '© 1985 LCASE GAMES').setOrigin(.5, 0).setDepth(5);
        // this.add.sprite(game.width/2, 2 * 16, 'logo').setOrigin(.5, 0);
        this.add.sprite(Game_1.game.width / 2, 2 * 16, 'logo_top').setOrigin(.5, 0);
        const best = Game_1.game.bestStreak.get();
        let logoColor = 'norm';
        if (best >= 3)
            logoColor = 'chry';
        else if (best >= 1)
            logoColor = 'gold';
        this.add.sprite(Game_1.game.width / 2, 6 * 16, `logo_${logoColor}`).setOrigin(.5, 0);
        const streak = Game_1.game.currentStreak.get();
        if (streak > 0) {
            this.add.bitmapText(Game_1.game.width / 2, 11 * 16, 'igo50', `STREAK: ${streak}`).setOrigin(.5, 0).setDepth(5);
        }
        this.updateStartText(KHInputProvider_1.KHInputProvider.lastInputSource);
        KHInputProvider_1.KHInputProvider.eventHandler.registerCallbackForObject("inputSourceUpdated", this, (ev) => {
            this.updateStartText(ev.inputSource);
        });
        this.events.on(Phaser.Scenes.Events.SHUTDOWN, () => {
            KHInputProvider_1.KHInputProvider.eventHandler.unregisterCallbacksForObject("inputSourceUpdated", this);
        });
        this.checkAchievements();
    }
    update(time, delta) {
        if (this._controller.getInput(Game_1.Controls.Confirm).isJustDown()) {
            Game_1.gameManager.addOrGetAudioScene(this).playSfx('move');
            this.scene.start(Z20SceneNames_1.default.RuleDisplay, { config: Z20TerminalSetup_1.Z20TerminalSetup.StandardSetup });
            return;
        }
        super.update(time, delta);
    }
    updateStartText(inputSource) {
        let key = 'Z';
        const source = inputSource ? inputSource.getInputType() : KHInputProvider_1.KHInputSourceType.Unknown;
        switch (source) {
            case KHInputProvider_1.KHInputSourceType.Unknown:
            case KHInputProvider_1.KHInputSourceType.Keyboard:
            case KHInputProvider_1.KHInputSourceType.Mouse:
                key = 'Z';
                break;
            case KHInputProvider_1.KHInputSourceType.Controller:
                const id = inputSource.getId().toLowerCase();
                if (id.includes('xbox'))
                    key = 'A';
                else if (id.includes('dualsense'))
                    key = 'X';
                break;
        }
        this._startText.setText(`PRESS ${key}`);
    }
    checkAchievements() {
        if (Game_1.game.bestStreak.get() >= 1)
            Game_1.game.achievements.unlock(Z20Achievements.Streak1);
        if (Game_1.game.bestStreak.get() >= 3)
            Game_1.game.achievements.unlock(Z20Achievements.Streak3);
        const scores = Game_1.game.highScores.get();
        if (scores.length > 0) {
            if (scores[0].score.time < 60)
                Game_1.game.achievements.unlock(Z20Achievements.Fast);
        }
    }
}
exports.default = Z20MenuScene;
